<template>
  <ProductForm is-edit />
</template>

<script>
import ProductForm from '@/layouts/components/form/ProductForm.vue'

export default {
  components: { ProductForm },
}
</script>
